import { ReactElement } from 'react';

import { clsx } from 'clsx';

import { IProps } from './types';
import * as S from './styles';

export function SliceLabeledIcons({ slice: { fields } }: IProps): ReactElement {
  return (
    <S.Wrapper className="labeled-icons">
      {fields && (
        <S.List className="labeled-icons__list">
          {fields.map((item, i) => (
            <S.Item
              key={i}
              className={clsx('labeled-icons__list-item', item.type || '')}
            >
              <S.Image className="labeled-icons__list-img">
                <img src={item.icon.url} alt="labeled-icons" />
              </S.Image>
              <span>{item.label}</span>
            </S.Item>
          ))}
        </S.List>
      )}
    </S.Wrapper>
  );
}

SliceLabeledIcons.componentName = 'labeled_icons';
